<template>
  <svg
    width="17px"
    height="17px"
    viewBox="0 0 17 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="#b4c1d6"
      fill-rule="evenodd"
    >
      <g
        id="SYN010---DSKTP---Připojit---3"
        transform="translate(-734.000000, -558.000000)"
      >
        <g
          id="ico/ico-i"
          transform="translate(734.000000, 558.000000)"
        >
          <g>
            <circle
              id="Oval-3"
              stroke="#b4c1d6"
              fill-rule="nonzero"
              cx="8.5"
              cy="8.5"
              r="8"
            ></circle>
            <path
              d="M10.3678936,12.1303978 L10.2314712,12.6884894 C9.82220205,12.8497166 9.49561841,12.9727022 9.25171052,13.0574499 C9.00780263,13.1421976 8.72462568,13.1845708 8.40217117,13.1845708 C7.90608732,13.1845708 7.52059461,13.0636521 7.24568147,12.8218112 C6.97076834,12.5799704 6.83331383,12.2730231 6.83331383,11.9009602 C6.83331383,11.7562691 6.84364876,11.6084796 6.86431892,11.4575875 C6.88498908,11.3066953 6.91806084,11.136169 6.96353519,10.9460036 L7.4720186,9.13530656 C7.51749295,8.96167721 7.55573218,8.7973519 7.58673742,8.64232569 C7.61774266,8.48729949 7.63324505,8.34571101 7.63324505,8.21755602 C7.63324505,7.98605022 7.58570439,7.82482539 7.49062165,7.73387668 C7.39553891,7.64292798 7.21364423,7.5974543 6.94493214,7.5974543 C6.81264312,7.5974543 6.6772556,7.61812415 6.53876552,7.65946448 C6.40027545,7.7008048 6.28142381,7.74007751 6.18220703,7.7772838 L6.31862941,7.21919226 C6.65348601,7.0827692 6.97386869,6.96598454 7.27978707,6.86883479 C7.58570544,6.77168504 7.87508335,6.72311089 8.14792947,6.72311089 C8.63987929,6.72311089 9.01917104,6.84196253 9.28581611,7.07966937 C9.55246119,7.31737622 9.68578172,7.62639048 9.68578172,8.00672144 C9.68578172,8.08526805 9.67648029,8.22375604 9.65787714,8.42218958 C9.639274,8.62062313 9.60516875,8.80251781 9.55556036,8.96787909 L9.04707695,10.7723751 C9.00573663,10.9170662 8.9685309,11.082425 8.93545865,11.2684565 C8.90238639,11.4544879 8.88585051,11.5950429 8.88585051,11.6901256 C8.88585051,11.9298995 8.93959212,12.0931913 9.04707695,12.180006 C9.15456179,12.2668206 9.34059044,12.3102273 9.6051685,12.3102273 C9.72918946,12.3102273 9.86974444,12.288524 10.0268377,12.2451167 C10.1839309,12.2017093 10.2976151,12.1634701 10.3678936,12.1303978 Z M10.498115,4.5589559 C10.498115,4.87314234 10.3792633,5.14081691 10.1415565,5.36198762 C9.90384963,5.58315834 9.61757221,5.69374204 9.28271561,5.69374204 C8.94785901,5.69374204 8.66054809,5.58315834 8.42077422,5.36198762 C8.18100036,5.14081691 8.06111523,4.87314234 8.06111523,4.5589559 C8.06111523,4.24476946 8.18100036,3.97606141 8.42077422,3.75282368 C8.66054809,3.52958594 8.94785901,3.41796875 9.28271561,3.41796875 C9.61757221,3.41796875 9.90384963,3.52958594 10.1415565,3.75282368 C10.3792633,3.97606141 10.498115,4.24476946 10.498115,4.5589559 Z"
              id="i"
              fill="#ffffff"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoInfo',
};
</script>
